export default __webpack_public_path__ + "static/media/lord-vishnu.c4990f80.jpg";